import ErrorToast from "../../../components/common/toasts/ErrorToast";
import React, { useEffect, useState } from "react";
import { Link, Navigate, useSearchParams } from "react-router-dom";
import usePremiumResource from "../hooks/usePremiumResource";
import { Field } from "./Fields";
import { pageIndex, premiumPaths } from "../navigation";

/** Jedna stronicowana lista dla administratora i wyboru firmy przez pracownika. */
export default function CompanyList({ token, admin = false }) {
  const [params, setParams] = useSearchParams();
  const query = params.get("q") || "";
  const page = pageIndex(params);
  const [search, setSearch] = useState(query);
  useEffect(() => setSearch(query), [query]);
  const { data, error, loading, reload } = usePremiumResource(
    token,
    `/account?page=${page}&q=${encodeURIComponent(query)}`,
  );
  const updateParams = (nextPage, nextQuery = query) => {
    const next = new URLSearchParams();
    if (nextQuery) next.set("q", nextQuery);
    if (nextPage) next.set("page", String(nextPage + 1));
    setParams(next);
  };
  if (
    !admin &&
    !query &&
    page === 0 &&
    !data?.hasMore &&
    data?.organizations.length === 1
  )
    return (
      <Navigate to={premiumPaths.orders(data.organizations[0].id)} replace />
    );
  return (
    <section className="card premium-panel">
      <h2>{admin ? "Dodane firmy" : "Wybierz firmę"}</h2>
      <form
        className="premium-search"
        onSubmit={(event) => {
          event.preventDefault();
          updateParams(0, search.trim());
        }}
      >
        <Field
          label="Szukaj firmy"
          value={search}
          onChange={(event) => setSearch(event.target.value)}
          maxLength={200}
        />
        <button className="btn btn-outline-primary">Szukaj</button>
      </form>
      <ErrorToast message={error} />
      {error && (
        <button className="btn btn-outline-primary" onClick={reload}>
          Ponów odczyt
        </button>
      )}
      {loading && <p role="status">Ładowanie firm…</p>}
      {data && (
        <>
          {data.organizations.length ? (
            <div className="table-responsive">
              <table className="table table-hover">
                <thead>
                  <tr>
                    <th>Firma</th>
                    <th>Status</th>
                    <th className="text-end">Operacje</th>
                  </tr>
                </thead>
                <tbody>
                  {data.organizations.map((company) => (
                    <tr key={company.id}>
                      <td>{company.name}</td>
                      <td>{company.active ? "Aktywna" : "Nieaktywna"}</td>
                      <td className="text-end">
                        <Link
                          className="btn btn-outline-primary btn-sm"
                          to={
                            admin
                              ? premiumPaths.settings(company.id)
                              : premiumPaths.orders(company.id)
                          }
                        >
                          {admin ? "Zarządzaj firmą" : "Świadectwa firmy"}
                          <span className="visually-hidden">
                            {" "}
                            {company.name}
                          </span>
                        </Link>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : (
            <p className="premium-empty">
              {query || page
                ? "Nie znaleziono firm na tej stronie."
                : admin
                  ? "Nie dodano jeszcze żadnej firmy Premium."
                  : "Nie przypisano Cię do firmy Premium. Administrator nadaje dostęp w sekcji „Firmy Premium”."}
            </p>
          )}
          {(page > 0 || data.hasMore) && (
            <div className="premium-pagination">
              <button
                className="btn btn-outline-primary"
                disabled={page === 0}
                onClick={() => updateParams(page - 1)}
              >
                Poprzednia
              </button>
              <span>Strona {page + 1}</span>
              <button
                className="btn btn-outline-primary"
                disabled={!data.hasMore}
                onClick={() => updateParams(page + 1)}
              >
                Następna
              </button>
            </div>
          )}
        </>
      )}
    </section>
  );
}
